var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTwigyyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 514,
    viewBox: "0 0 574 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.805 2.76935C471.188 -10.5451 446.158 54.5476 445.346 88.7583C462.411 108.175 498.98 102.627 518.484 94.3058C537.987 85.9843 552.615 69.3413 564.805 38.8291C574.557 14.4193 576.994 5.54304 564.805 2.76935Z",
    fill: "url(#paint0_linear_2682_954)",
    stroke: "#DEFF04",
    strokeOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461.814 159.837C447.664 149.152 443.145 127.079 442.654 117.379C464.854 110.154 479.548 119.251 482.075 121.159C484.602 123.068 486.597 125.907 487.594 127.327L487.595 127.327C509.011 159.494 479.501 173.194 461.814 159.837Z",
    fill: "url(#paint1_linear_2682_954)",
    stroke: "#DEFF04",
    strokeOpacity: 0.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.743 133.344C138.264 167.126 138.95 236.681 141.354 267.236C148.563 223.979 162.994 211.394 194.91 192.051C228.898 171.452 328.802 180.721 372.06 175.572C415.317 170.422 436.946 123.045 426.647 90.0868C418.407 63.7204 394.719 45.7994 374.12 41.6797H275.246C211.389 41.6797 175.342 91.1167 154.743 133.344Z",
    fill: "url(#paint2_linear_2682_954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6285 178.051C66.3962 178.051 118.443 178.661 143.161 178.661C149.55 142.569 163.366 111.828 181.269 91.1167C209.549 58.401 246.173 46.0936 265.724 42.0993H172.892C138.904 41.4127 65.7782 41.0694 45.1795 45.1891C19.431 50.3388 -9.40727 85.3567 2.95199 125.524C15.3112 165.692 53.419 178.051 60.6285 178.051Z",
    fill: "url(#paint3_linear_2682_954)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.15 447.036V178.222C172.924 175.75 143.124 237.615 140.378 268.857C140.034 323.787 139.554 437.561 140.378 453.216C141.408 472.785 160.977 515.012 210.414 513.982C249.963 513.158 266.717 469.008 270.15 447.036Z",
    fill: "url(#paint4_linear_2682_954)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_954",
    x1: 464.849,
    y1: 98.0842,
    x2: 572.264,
    y2: 20.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ED21",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#DEFF04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2682_954",
    x1: 445.18,
    y1: 119.287,
    x2: 489.126,
    y2: 151.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F7FD",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2682_954",
    x1: 385.449,
    y1: 85.967,
    x2: 170.192,
    y2: 168.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04FF1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2682_954",
    x1: 168.772,
    y1: 109.045,
    x2: 0.00000295957,
    y2: 70.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04ACA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#04BC9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00FE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FE3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2682_954",
    x1: 205.036,
    y1: 178.15,
    x2: 237.767,
    y2: 513.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#006599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0697C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTwigyyLogo);
export default __webpack_public_path__ + "static/media/small_twigyy_logo.67e772bb2e57bd1ee36a03ccdda1bfe0.svg";
export { ForwardRef as ReactComponent };